import OrderItemTimeLine from '@/components/Orders/OrderItemCompleteTimeline'
import Vue from 'vue'
import VueRouter from 'vue-router'
import OrdersDetail from './components/Orders/Detail'
import OrdersList from './components/Orders/List'
import TrackingRuler from './components/Tracking/Ruler'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: 'meus-pedidos' },
  { name: 'orders', path: '/meus-pedidos', component: OrdersList },
  { path: '/tracking', component: TrackingRuler },
  { path: '/meus-pedidos/pedido/:id', component: OrdersDetail },
  { path: '/meus-pedidos/pedido/:id/timeline', component: OrderItemTimeLine, name: 'orderItemTimeline' }
]

export default new VueRouter({
  mode: 'history',
  routes
})
